/**
 * Limpia espacios en blanco de un texto
 * @param {string} text - El texto que se desea limpiar
 * @returns {string} El texto limpio
 */
export function cleanSpaces(text) {
	return text.replace(/\s+/g, " ").trim()
}
export function isValidEmail(email) {
	const reEmail =
		/^(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/
	return reEmail.test(email)
}
